"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            WindowManager_HostClosed: "This window is now read-only because the connection with the host window was lost.",
        },
    });
    $(window).on("Popout", function (evt) {
        // We handle this command client side so prevent the default action and initiate the action.
        evt.preventDefault();
        $dyn.callWhenNotBusy($dyn.serverForm._popout);
    });
    var serverForm;
    (function (serverForm) {
        /**
         * Size of the popout in relation to the parent window
         * @private
         */
        serverForm._popoutWindowSizePercentage = 80 / 100;
        serverForm._windowId = 0;
        /**
         * Called whenever a user clicks the "Popout current form" button on a window.
         * It is in charge of calling the WindowManager (proxy or real) to start the popout process with the current form's root ID.
         * @private
         */
        function _popout() {
            // get rootId from the current form in the navigation stack
            var rootId = null;
            var activeForm = $dyn.shell.getCurrentRootForm();
            var form = null;
            if (activeForm && activeForm.dynOptions && activeForm.dynOptions._serverId) {
                form = $dyn.context(activeForm);
                rootId = form.Id;
            }
            if (form) {
                var eventOptions = {
                    userDefined1: $dyn.serverForm._windowId,
                };
                $dyn.telemetry.addFormActionEvent(form, $dyn.telemetry.ActionEvents.formPopout, eventOptions);
            }
            $dyn.serverForm._windowManager.prePopout({ rootId: rootId });
        }
        serverForm._popout = _popout;
        /**
         * Definition of the function names used with calling between proxy and real WindowManager.
         * @internal
         */
        var _WindowManagerFunction;
        (function (_WindowManagerFunction) {
            _WindowManagerFunction["prePopout"] = "prePopout";
            _WindowManagerFunction["windowLoadCallback"] = "windowLoadCallback";
            _WindowManagerFunction["closeWindow"] = "closeWindow";
            _WindowManagerFunction["hostClosed"] = "hostClosed";
            _WindowManagerFunction["globalBlocked"] = "globalBlocked";
            _WindowManagerFunction["globalUnBlocked"] = "globalUnBlocked";
            _WindowManagerFunction["requestClosePopout"] = "requestClosePopout";
            _WindowManagerFunction["forceClosePopout"] = "forceClosePopout";
            _WindowManagerFunction["notifyFormReserialized"] = "notifyFormReserialized";
            _WindowManagerFunction["notifyFormDetached"] = "notifyFormDetached";
            _WindowManagerFunction["notifyFocusWindow"] = "notifyFocusWindow";
            _WindowManagerFunction["transferUserSettings"] = "transferUserSettings";
            _WindowManagerFunction["transferShellSettings"] = "transferShellSettings";
        })(_WindowManagerFunction = serverForm._WindowManagerFunction || (serverForm._WindowManagerFunction = {}));
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Popout.js.map
